<template>
  <div class="contact-container">
    <div>
      <gmap-map
        :center="location"
        :zoom="15"
        class="map-container"
      >
        <gmap-marker
          :position="location"
          :clickable="true"
          :draggable="true"
          @click="center=location"
        ></gmap-marker>
      </gmap-map>
    </div>

    <p class="call-to-action-pitch">Send me your building plans or the quantity in cubic meters you need and I will get you a price within 24 hours.</p>

    <div class="details">
      Email: <a href="mailto:jonathan@siberianlarchwood.co.nz">jonathan@siberianlarchwood.co.nz</a><br><br>
      Phone: <a href="tel:0211098193">0211098193</a><br><br>
      Address: <br>81 Dunkirk Rd<br>Panmure, Auckland, 1072
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        location: {lat: -36.894298, lng: 174.867250}
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .contact-container {
    padding-top: 65px;
    min-height: 100vh;
    padding-bottom: 32px;
  }
  .details {
    width: 100vw;
    max-width: 400px;
    font-size: 120%;
    text-align: left;
    padding-left: 10px;
    color: #000;
    margin: auto;
  }
  .map-container {
    width: 100vw;
    height: 40vh;
    background: url('../../static/img/preload.gif') no-repeat center center;
    background-size: auto;
  }
  .call-to-action-pitch {
    font-size: 120%;
    font-weight: 600;
    text-align: left;
    padding: 8px;
    margin-top: 32px;
  }
  /*large screen*/
  @media screen and (min-width: 767px) {
    .call-to-action-pitch {
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// Contact.vue?73a7c630